// Full-document render of the anonymous order-lookup ("Find Your Order")
// page (/orders/): PageSkeleton wrapping the legacy sealy lookup body.
import React from "react";

import { templates } from "@reactivated";

import { OrderLookupPageBody } from "../components/OrderLookupPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderLookupDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderLookupPageBody {...props} />
    </PageSkeleton>
);
